// Contratto client/server delle chiamate vocali.

// Inviato dal client come messaggio utente (sendUserMessage) quando restano
// pochi secondi: il Custom LLM lo riconosce e fa salutare il companion invece
// di lasciare che la chiamata venga tagliata. Mai mostrato ne' salvato.
export const VOICE_TIME_UP_SIGNAL = "[[fine-tempo-chiamata]]";

// Secondi prima della fine in cui il client manda il segnale di fine tempo.
export const VOICE_CLIENT_TIME_UP_LEAD_SECONDS = 12;

// Un profilo si puo' chiamare ADESSO: AI con voce assegnata, non fermo per
// moderazione, e online (o configurato come sempre online). Usata sia per
// mostrare il pulsante chiamata sia per accettare la chiamata lato server.
// Il badge nella ricerca invece guarda solo la voce: dice "ha la voce", non
// "risponde adesso".
export function isProfileCallableNow(profile: {
  isAiProfile?: boolean | null;
  voiceId?: string | null;
  isOnline?: boolean | null;
  aiAlwaysOnline?: boolean | null;
  aiModerationHold?: boolean | null;
} | null | undefined): boolean {
  if (!profile?.isAiProfile || !profile.voiceId || profile.aiModerationHold) return false;
  return !!profile.isOnline || !!profile.aiAlwaysOnline;
}

// Risposta di POST /api/voice/calls.
export interface StartVoiceCallResponse {
  callId: string;
  conversationToken: string;
  // Da passare a ElevenLabs come customLlmExtraBody.call_token.
  callToken: string;
  voiceId: string;
  firstMessage: string;
  allowedSeconds: number;
}

// Codici di errore di POST /api/voice/calls, gestiti dalla UI.
export type StartVoiceCallError =
  | "voice_disabled"
  | "profile_not_callable"
  | "minutes_exhausted"
  | "provider_error";

// Stati che il client puo' segnalare su POST /api/voice/calls/:id/status.
// "ended" = chiamata connessa e chiusa: la durata ufficiale arriva poi dal webhook.
export type ClientCallStatus = "active" | "ended" | "rejected" | "missed" | "failed";
